// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"SidePanel-module_overlay_d5249","backdrop":"SidePanel-module_backdrop_f36e2"};